import { AttackChainCommandEnum, AttackChainCommandTactics } from '@/constants/attack-chain.constants'
/**
 * Number of cyber kill chains (12)
 *
 */
export function getKillChainTicks () {
  let killChainTicks = []
  killChainTicks.length = AttackChainCommandTactics.length
  killChainTicks.fill(1)
  return killChainTicks
}

/**
 * Fill ticks and label for MITRE ATT&CK chain command according to
 * https://attack.mitre.org/matrices/enterprise/linux/
 *
 *
 */
export function buildAttackChainCommand (attackChainsExecuted) {
  let killChainTicks = getKillChainTicks()
  let backgroundColor = []
  let labels = []
  backgroundColor.length = AttackChainCommandTactics.length
  backgroundColor.fill('rgba(0, 0, 0, 0.1)')

  for (let command in AttackChainCommandEnum.properties) {
    // command ie:
    // {
    //   step: 1,
    //   title: 'Initial Access',
    //   command: 'INITIAL_ACCESS'
    // }
    if (attackChainsExecuted.includes(AttackChainCommandEnum.properties[command].command)) {
      backgroundColor.splice(AttackChainCommandEnum.properties[command].step - 1, 1, '#ff5a83')
    }
    labels.push(AttackChainCommandEnum.properties[command])
  }

  labels = _.map(_.sortBy(labels, 'step'), 'title')

  return { data: killChainTicks, backgroundColor, labels }
}

export function getAttackChainCommand (command) {
  let attackChain = AttackChainCommandEnum.properties[AttackChainCommandEnum[command]]

  if (attackChain instanceof Object === false) {
    return {
      step: -1,
      title: command,
      command: command
    }
  } else {
    return attackChain
  }
}



// WEBPACK FOOTER //
// ./src/utilities/attack-chain.helper.js